import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import './chat-emoji/chat-emoji-overrides.css'
import './styles/official-admin.css'
import App from './App.vue'
import router from './router'

document.documentElement.classList.add('admin-shell')

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.mount('#app')
